import 'types/Shared/Locale'
import '../types'
type MenuItem = {
  title: string
  link: string
}
export const getShortcutsMenuList = (): ReadonlyArray<MenuItem> => {
  const menuList = [
    {
      title: 'Paintings',
      link: '/paintings',
    },
    {
      title: 'Abstract Art',
      link: '/all/abstract',
    },
    {
      title: 'Curated Deals',
      link: '/curated-deals',
    },
    {
      title: 'Oil Paintings',
      link: '/paintings/oil',
    },
    {
      title: 'Landscapes',
      link: '/all/landscape',
    },
    {
      title: 'Large Works',
      link: '/all/large?size=oversized',
    },
    {
      title: 'Acrylic Paintings',
      link: '/paintings/acrylic',
    },
    {
      title: 'Curated Collections',
      link: '/collections/featured',
    },
    {
      title: 'Modern Art',
      link: '/all/modern',
    },
    {
      title: 'Sculpture',
      link: '/sculpture',
    },
  ]
  return menuList
}

export const IMAGE_URLS: ReadonlyArray<string> = [
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image01.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image02.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image03.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image04.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image05.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image06.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image07.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image08.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image09.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image10.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image11.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image12.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image13.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image14.jpg',
  '//d3t95n9c6zzriw.cloudfront.net/homepage/anniversaryImages/image15.jpg',
]

type StatItem = {
  count: string
  text: string
}

export const STATS: ReadonlyArray<StatItem> = [
  { count: '15', text: 'Years of living with art, made easy' },
  { count: '130,000+', text: 'Homes with art' },
  { count: '153', text: 'Collector countries' },
  { count: '100,000+', text: 'Artists collected' },
  { count: '330,000+', text: 'Artworks sold' },
  { count: '143', text: 'Artist countries' },
]
